import React from "react";
import { useTranslation } from "react-i18next";

import { GeoLocationControl } from "./styled";
import { useGeoLocation } from "../../hooks/useGeoLocation";

export const GeoLocationButton = () => {
  const { t } = useTranslation("mapControls");
  const { geoLocationFeature, geoLocationMode, watchGeoLocation } = useGeoLocation();

  return (
    <GeoLocationControl
      primary={!!geoLocationFeature?.length}
      title={t("geoLocation")}
      onClick={watchGeoLocation}
      mode={geoLocationMode}
    />
  );
};
